import React from 'react';
import { Card, Row, Col, Statistic } from 'antd';
import { UserOutlined, FileTextOutlined, ClockCircleOutlined, DollarOutlined } from '@ant-design/icons';

const StatsCards = ({ stats = {} }) => {
  return (
    <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
      <Col xs={24} sm={12} md={6}>
        <Card>
          <Statistic
            title="Total Employees"
            value={stats.totalEmployees || 0}
            prefix={<UserOutlined />}
            valueStyle={{ color: '#1890ff' }}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card>
          <Statistic
            title="Pending Leaves"
            value={stats.pendingLeaves || 0}
            prefix={<FileTextOutlined />}
            valueStyle={{ color: '#faad14' }}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card>
          <Statistic
            title="Present Today"
            value={stats.presentToday || 0}
            prefix={<ClockCircleOutlined />}
            valueStyle={{ color: '#52c41a' }}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card>
          <Statistic
            title="This Month Payroll"
            value={stats.monthlyPayroll || 0}
            prefix={<DollarOutlined />}
            valueStyle={{ color: '#eb2f96' }}
            precision={2}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default StatsCards;
